import React from 'react'
import LoginTuotr from '../../Components/tutor/Login'
function Login() {
  return (
    <div>
      <LoginTuotr/>
    </div>
  )
}

export default Login
